/**
 * WebsiteTech AI Launch Program — frontend API client.
 * Kept in its own module so it can be reused by the wizard, admin dash,
 * preview viewer and status portal without pulling the whole app tree.
 */
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const http = axios.create({ baseURL: `${BASE}/api`, timeout: 30000 });

// Admin endpoints need the WebsiteTech Bearer JWT.
http.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" && localStorage.getItem("wt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const launchVerticals = () => http.get("/launch/verticals").then(r => r.data);
export const launchApply = (step1) => http.post("/launch/apply", step1).then(r => r.data);
export const launchStep = (appId, step, payload) =>
  http.post(`/launch/${appId}/step`, { step, payload }).then(r => r.data);
export const launchOtpSend = (appId) => http.post(`/launch/${appId}/otp/send`).then(r => r.data);
export const launchOtpVerify = (appId, code) =>
  http.post(`/launch/${appId}/otp/verify`, { code }).then(r => r.data);
export const launchStatus = (publicToken) =>
  http.get(`/launch/status/${publicToken}`).then(r => r.data);
export const launchPreview = (publicToken) =>
  http.get(`/launch/preview/${publicToken}`).then(r => r.data);
export const launchGetPrivate = (appId) =>
  http.get(`/launch/${appId}`).then(r => r.data);

export const launchShowcaseDetail = (slug) =>
  http.get(`/launch/showcase/${slug}`).then(r => r.data);
export const launchShowcaseList = () =>
  http.get("/launch/showcase").then(r => r.data);

// Admin
export const adminLaunchList = (params = {}) =>
  http.get("/admin/launch/applications", { params }).then(r => r.data);
export const adminLaunchDecide = (appId, payload) =>
  http.post(`/admin/launch/applications/${appId}/decide`, payload).then(r => r.data);
export const adminLaunchScreenshotRefresh = (slug, screenshot_url) =>
  http.post(`/admin/launch/showcase/${slug}/screenshot/refresh`, { screenshot_url }).then(r => r.data);
